import React, {Component} from 'react';
import SoundsList from './SoundsList';
import './Home.css';
import 'bootstrap/dist/css/bootstrap.css';
import './Jumbotron.css';
import {Button} from 'reactstrap';
import firebase, {auth, provider} from './firebase.js';
import {BrowserRouter as Router, Route, Link} from "react-router-dom";

class Home extends Component {
    constructor() {
        super();
    }

    render() {
        return (

            <React.Fragment>


                <section className="jumbotron text-center">
                    <div className="container">
                        <h1 className="jumbotron-heading">ASMR Sounds</h1>
                        <p className="lead text-muted">Mix different sounds and create your perfect environment for
                            working, relaxing or sleeping</p>


                        <div className="wrapper">
                            {this.props.user.email ?
                                <Button outline color="danger" onClick={this.props.logout}>Log out</Button>
                                :
                                <span>
                                        <Button onClick={this.props.login} color="primary">Sign up</Button>{' '}
                                    <Button outline color="primary" onClick={this.props.login}>Log in</Button>
                                    </span>

                            }
                        </div>

                        <a target="_blank" href='https://play.google.com/store/apps/details?id=com.firebaseapp.asmrwaves&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'><img class="google-play-badge" alt='Get it on Google Play' src='https://play.google.com/intl/en_us/badges/images/generic/en_badge_web_generic.png'/></a>


                        {/*{this.state.user ?*/}
                        {/*<div>*/}
                        {/*<div className='user-profile'>*/}
                        {/*<img src={this.state.user.photoURL} />*/}
                        {/*</div>*/}
                        {/*</div>*/}
                        {/*: <span></span>*/}
                        {/*}*/}
                    </div>
                </section>

                <SoundsList
                    userId={this.props.user.uid}
                    username={this.props.user.email}/>


            </React.Fragment>
        );
    }
}

export default Home;



// WEBPACK FOOTER //
// ./src/Home.js